import React, { useState, useEffect, useCallback } from 'react';
import { Box, Button, Paper, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Stepper, Step, StepLabel, StepContent, CircularProgress, IconButton, MenuItem, ListItemIcon, ListItemText, Tabs, Tab, Card, CardHeader, CardContent } from "@mui/material"
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { PetModal } from "../components/PetModal"
import { useForm, Controller } from "react-hook-form"
import { toast } from "react-toastify"
import Layout from "../components/Layout"
import { IMaskInput } from "react-imask";
import { CompanyAPI } from "../api/CompanyAPI";
import { WhatsappAPI } from "../api/WhatsappAPI";
import ConfirmButton from "../components/ConfirmButton";
import { Container } from '../components/Container';
import getZipcodeInformations, { getStates } from '../api/CepAPI';
import { FilterCompany } from '../components/FilterCompany';

export const Company = () => {

    const [openModalCompany, setOpenModalCompany] = useState(false)
    const [statesOptions, setStateOptions] = useState([])
    const [openModalEdit, setOpenModalEdit] = useState(false)
    const [activeStep, setActiveStep] = useState(0)
    const [rows, setRows] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [loadingCep, setLoadingCep] = useState(false)
    const [currentTab, setCurrentTab] = useState(0)
    const [whatsappQrCode, setWhatsappQrCode] = useState(null)
    const [loadingWhatsapp, setLoadingWhatsapp] = useState(false)
    const [loading, setLoading] = useState({
        create: false,
        edit: false,
        delete: false,
        loadData: false
    });

    const loadData = useCallback(async (data) => {
        setLoading(prev => ({ ...prev, loadData: true }));
        try {
            const response = await CompanyAPI.getCompanies(data);
            if (response.success) {
                setRows(response.data.companies || []);
                const resultState = await getStates()

                if (resultState.length > 0) {
                    setStateOptions(resultState.map(s => s.sigla))
                }
            } else {
                toast.error(response.message || "Erro ao carregar dados")
            }
        } catch (error) {
            console.error("Erro ao carregar empresas:", error);
            toast.error("Erro ao carregar dados");
        } finally {
            setLoading(prev => ({ ...prev, loadData: false }));
        }
    }, []);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const loadWhatsappQrCode = useCallback(async () => {
        setLoadingWhatsapp(true);
        try {
            const response = await WhatsappAPI.getWhatsapp();
            if (response.success) {
                setWhatsappQrCode(response.data);
            } else {
                toast.error(response.message || "Erro ao carregar QR Code do WhatsApp");
            }
        } catch (error) {
            console.error("Erro ao carregar QR Code do WhatsApp:", error);
            toast.error("Erro ao carregar QR Code do WhatsApp");
        } finally {
            setLoadingWhatsapp(false);
        }
    }, []);

    useEffect(() => {
        if (currentTab === 1) {
            loadWhatsappQrCode();
        }
    }, [currentTab, loadWhatsappQrCode]);

    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    };

    const defaultValuesCreate = {
        name: "",
        document: "",
        email: "",
        phone: "",
        address: "",
        city: "",
        state: "",
        zipcode: "",
        user_name: "",
        user_email: "",
        user_phone: "",
        user_document: "",
        user_password: ""
    }

    const methods = useForm({ defaultValues: defaultValuesCreate })
    const editMethods = useForm({
        defaultValues: {
            name: "",
            document: "",
            email: "",
            phone: "",
            address: "",
            city: "",
            state: "",
            zipcode: ""
        }
    })

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
        methods.reset(defaultValuesCreate);
    };

    const handleEditCompany = async (company) => {
        setLoading({ ...loading, edit: true });
        try {
            const response = await CompanyAPI.getCompanyById(company.guid);
            if (response.success) {
                const companyData = response.data.company;
                setSelectedCompany(companyData);
                setOpenModalEdit(true);

                // Preencher o formulário com os dados atualizados da empresa
                editMethods.reset({
                    name: companyData.name || "",
                    document: companyData.document || "",
                    email: companyData.email || "",
                    phone: companyData.phone || "",
                    address: companyData.address || "",
                    city: companyData.city || "",
                    state: companyData.state || "",
                    zipcode: companyData.zipcode || ""
                });
            } else {
                toast.error(response.message || "Erro ao carregar dados da empresa");
            }
        } catch (error) {
            console.error("Erro ao carregar empresa:", error);
            toast.error("Erro ao carregar dados da empresa");
        } finally {
            setLoading({ ...loading, edit: false });
        }
    };

    const handleCloseEditModal = () => {
        setOpenModalEdit(false);
        setSelectedCompany(null);
        editMethods.reset();
    };

    const handleClick = (event, company) => {
        setAnchorEl(event.currentTarget);
        setSelectedCompany(company);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedCompany(null);
    };

    const handleDeleteCompany = async (company) => {
        setLoading({ ...loading, delete: true });
        try {
            const result = await CompanyAPI.deleteCompany(company.guid || company.id);
            if (result.success) {
                toast.success(result.message);
                loadData();
                handleClose();
            } else {
                toast.error(result.message || 'Erro ao excluir empresa');
            }
        } catch (error) {
            toast.error("Erro ao excluir empresa");
        } finally {
            setLoading({ ...loading, delete: false });
        }
    };

    async function submit(data) {
        const companyData = {
            name: data.name,
            document: data.document,
            email: data.email,
            phone: data.phone,
            address: data.address,
            city: data.city,
            state: data.state,
            zipcode: data.zipcode
        }
        const userData = {
            name: data.user_name,
            email: data.user_email,
            phone: data.user_phone,
            document: data.user_document,
            password: data.user_password
        }

        try {
            let response;

            if (selectedCompany) {
                setLoading({ ...loading, edit: true });
                response = await CompanyAPI.updateCompany(selectedCompany.guid || selectedCompany.id, companyData);
            } else {
                setLoading({ ...loading, create: true });
                const body = {
                    company: companyData,
                    user: userData
                }
                response = await CompanyAPI.createCompany(body);
            }

            if (response.success) {
                setOpenModalCompany(false);
                setOpenModalEdit(false);
                handleReset();
                loadData();
                toast.success(response.message);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error("Erro ao salvar empresa");
        } finally {
            if (selectedCompany) {
                setLoading({ ...loading, edit: false });
            } else {
                setLoading({ ...loading, create: false });
            }
        }
    }

    const handleOpenModalCompany = () => {
        methods.reset(defaultValuesCreate);
        setOpenModalCompany(true);
    }

    const loadCep = async (cep, formMethods) => {
        setLoadingCep(true)
        let cepFound
        try {
            if (cep) {
                cepFound = await getZipcodeInformations(cep);
            }
        }
        catch (error) {
            console.log(error)
            setLoadingCep(false)
            toast.warning("Ocorreu um erro ao carregar CEP")
            return
        }
        if (cepFound.erro) {
            methods.setError("zipcode", { message: "CEP inválido" });
        } else {
            formMethods.clearErrors("zipcode");
            formMethods.setValue("address", cepFound.logradouro || "");
            formMethods.setValue("city", cepFound.localidade || "");
            formMethods.setValue("state", cepFound.uf || "");
        }

        setLoadingCep(false)
        return cepFound
    }

    let cep = methods.watch("zipcode")
    useEffect(() => {
        const cepClean = (cep || "").replace(/\D/g, '');
        if (cepClean.length === 8) {
            loadCep(cepClean, methods)
        }
    }, [cep])

    let cepEdit = editMethods.watch("zipcode")
    useEffect(() => {
        const cepClean = (cepEdit || "").replace(/\D/g, '');
        if (cepClean.length === 8) {
            loadCep(cepClean, editMethods)
        }
    }, [cepEdit])

    return (
        <>
            <PetModal
                open={openModalCompany}
                onClose={() => {
                    setOpenModalCompany(false);
                    handleReset();
                }}
                title="Nova Empresa"
                size={'medium'}
                formId='company-form'
                loading={loading.create}
            >
                <form id='company-form' onSubmit={methods.handleSubmit(submit)}>
                    <Stepper activeStep={activeStep} orientation="vertical">
                        <Step>
                            <StepLabel>Dados da Empresa</StepLabel>
                            <StepContent>
                                <Box display='flex' flexDirection='column' className='gap-1' sx={{ mb: 2 }}>
                                    <Controller
                                        name="name"
                                        control={methods.control}
                                        rules={{ required: "Nome é obrigatório" }}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                id="company-name"
                                                label="Nome da Empresa"
                                                variant="outlined"
                                                error={!!error}
                                                helperText={error?.message}
                                            />
                                        )}
                                    />
                                    <Controller
                                        name="document"
                                        control={methods.control}
                                        rules={{ required: "CNPJ é obrigatório" }}
                                        render={({ field: { ref, ...field }, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                id="company-document"
                                                label="CNPJ"
                                                variant="outlined"
                                                inputRef={ref}
                                                error={!!error}
                                                helperText={error?.message}
                                                InputProps={{
                                                    inputComponent: IMaskInput,
                                                }}
                                                inputProps={{
                                                    mask: "00.000.000/0000-00"
                                                }}
                                            />
                                        )}
                                    />
                                    <Controller
                                        name="email"
                                        control={methods.control}
                                        rules={{ required: "Email é obrigatório" }}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                id="company-email"
                                                label="Email da Empresa"
                                                variant="outlined"
                                                type="email"
                                                error={!!error}
                                                helperText={error?.message}
                                            />
                                        )}
                                    />
                                    <Controller
                                        name="phone"
                                        control={methods.control}
                                        rules={{ required: "Telefone é obrigatório" }}
                                        render={({ field: { ref, ...field }, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                id="company-phone"
                                                label="Telefone da Empresa"
                                                variant="outlined"
                                                type="tel"
                                                inputRef={ref}
                                                error={!!error}
                                                helperText={error?.message}
                                                InputProps={{
                                                    inputComponent: IMaskInput,
                                                }}
                                                inputProps={{
                                                    mask: "(00)00000-0000"
                                                }}
                                            />
                                        )}
                                    />
                                    <Controller
                                        name="zipcode"
                                        control={methods.control}
                                        rules={{
                                            required: "CEP é obrigatório",
                                            pattern: {
                                                value: /^\d{5}-\d{3}$/,
                                                message: "CEP deve estar no formato 00000-000"
                                            }
                                        }}
                                        render={({ field: { ref, ...field }, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                id="outlined-basic"
                                                label="CEP"
                                                variant="outlined"
                                                inputRef={ref}
                                                error={!!error}
                                                helperText={error?.message}
                                                InputProps={{
                                                    inputComponent: IMaskInput,
                                                }}
                                                inputProps={{
                                                    mask: "00000-000"
                                                }}
                                            />
                                        )}
                                    />
                                    <Controller
                                        name="address"
                                        control={methods.control}
                                        rules={{ required: "Endereço é obrigatório" }}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                id="company-address"
                                                label="Endereço"
                                                variant="outlined"
                                                error={!!error}
                                                helperText={error?.message}
                                                disabled={loadingCep}
                                            />
                                        )}
                                    />
                                    <Box display='flex' gap={1}>
                                        <Controller
                                            name="city"
                                            control={methods.control}
                                            rules={{ required: "Cidade é obrigatória" }}
                                            render={({ field, fieldState: { error } }) => (
                                                <TextField
                                                    {...field}
                                                    id="company-city"
                                                    label="Cidade"
                                                    variant="outlined"
                                                    error={!!error}
                                                    helperText={error?.message}
                                                    disabled={loadingCep}
                                                />
                                            )}
                                        />
                                        <Controller
                                            name="state"
                                            control={methods.control}
                                            rules={{ required: "Estado é obrigatório" }}
                                            render={({ field, fieldState: { error } }) => (
                                                <TextField
                                                    {...field}
                                                    select
                                                    id="outlined-basic"
                                                    label="Estado"
                                                    variant="outlined"
                                                    disabled={loadingCep}
                                                    error={!!error}
                                                    helperText={error?.message}
                                                    sx={{ minWidth: 200 }}
                                                >
                                                    {statesOptions.map((option) => (
                                                        <MenuItem key={option} value={option}>
                                                            {option}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            )}
                                        />
                                    </Box>
                                </Box>

                                <Box>
                                    <Button
                                        variant="contained"
                                        onClick={handleNext}
                                        sx={{ mt: 1, mr: 1 }}
                                    >
                                        Próximo
                                    </Button>
                                </Box>
                            </StepContent>
                        </Step>

                        <Step>
                            <StepLabel>Usuário Administrador</StepLabel>
                            <StepContent>
                                <Box display='flex' flexDirection='column' className='gap-1' sx={{ mb: 2 }}>
                                    <Controller
                                        name="user_name"
                                        control={methods.control}
                                        rules={{ required: "Nome do usuário é obrigatório" }}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                id="user-name"
                                                label="Nome do Usuário"
                                                variant="outlined"
                                                error={!!error}
                                                helperText={error?.message}
                                            />
                                        )}
                                    />
                                    <Controller
                                        name="user_email"
                                        control={methods.control}
                                        rules={{ required: "Email do usuário é obrigatório" }}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                id="user-email"
                                                label="Email do Usuário"
                                                variant="outlined"
                                                type="email"
                                                error={!!error}
                                                helperText={error?.message}
                                            />
                                        )}
                                    />
                                    <Controller
                                        name="user_phone"
                                        control={methods.control}
                                        rules={{ required: "Telefone do usuário é obrigatório" }}
                                        render={({ field: { ref, ...field }, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                id="user-phone"
                                                label="Telefone do Usuário"
                                                variant="outlined"
                                                type="tel"
                                                inputRef={ref}
                                                error={!!error}
                                                helperText={error?.message}
                                                InputProps={{
                                                    inputComponent: IMaskInput,
                                                }}
                                                inputProps={{
                                                    mask: "(00)00000-0000"
                                                }}
                                            />
                                        )}
                                    />
                                    <Controller
                                        name="user_document"
                                        control={methods.control}
                                        rules={{ required: "CPF do usuário é obrigatório" }}
                                        render={({ field: { ref, ...field }, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                id="user-document"
                                                label="CPF do Usuário"
                                                variant="outlined"
                                                inputRef={ref}
                                                error={!!error}
                                                helperText={error?.message}
                                                InputProps={{
                                                    inputComponent: IMaskInput,
                                                }}
                                                inputProps={{
                                                    mask: "000.000.000-00"
                                                }}
                                                InputLabelProps={{ shrink: !!field.value }}
                                            />
                                        )}
                                    />
                                    <Controller
                                        name="user_password"
                                        control={methods.control}
                                        rules={{ required: "Senha é obrigatória" }}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                id="user-password"
                                                label="Senha"
                                                variant="outlined"
                                                type="password"
                                                error={!!error}
                                                helperText={error?.message}
                                            />
                                        )}
                                    />
                                </Box>

                                <Box>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        sx={{ mt: 1, mr: 1 }}
                                    >
                                        Finalizar Cadastro
                                    </Button>
                                    <Button
                                        onClick={handleBack}
                                        sx={{ mt: 1, mr: 1 }}
                                    >
                                        Voltar
                                    </Button>
                                </Box>
                            </StepContent>
                        </Step>
                    </Stepper>
                </form>
            </PetModal>

            <PetModal
                open={openModalEdit}
                onClose={handleCloseEditModal}
                title="Editar Empresa"
                size={'medium'}
                formId='edit-company-form'
                loading={loading.edit}
            >
                <form id='edit-company-form' onSubmit={(e) => {
                    editMethods.handleSubmit(submit)(e);
                }}>

                    <Box display='flex' flexDirection='column' className='gap-1' sx={{ mb: 2 }}>
                        <Controller
                            name="name"
                            control={editMethods.control}
                            rules={{ required: "Nome é obrigatório" }}
                            render={({ field, fieldState: { error } }) => (
                                <TextField
                                    {...field}
                                    id="edit-company-name"
                                    label="Nome da Empresa"
                                    variant="outlined"
                                    error={!!error}
                                    helperText={error?.message}
                                />
                            )}
                        />
                        <Controller
                            name="document"
                            control={editMethods.control}
                            rules={{ required: "CNPJ é obrigatório" }}
                            render={({ field: { ref, ...field }, fieldState: { error } }) => (
                                <TextField
                                    {...field}
                                    id="edit-company-document"
                                    label="CNPJ"
                                    variant="outlined"
                                    inputRef={ref}
                                    error={!!error}
                                    helperText={error?.message}
                                    InputProps={{
                                        inputComponent: IMaskInput,
                                    }}
                                    inputProps={{
                                        mask: "00.000.000/0000-00"
                                    }}
                                />
                            )}
                        />
                        <Controller
                            name="email"
                            control={editMethods.control}
                            rules={{ required: "Email é obrigatório" }}
                            render={({ field, fieldState: { error } }) => (
                                <TextField
                                    {...field}
                                    id="edit-company-email"
                                    label="Email da Empresa"
                                    variant="outlined"
                                    type="email"
                                    error={!!error}
                                    helperText={error?.message}
                                />
                            )}
                        />
                        <Controller
                            name="phone"
                            control={editMethods.control}
                            rules={{ required: "Telefone é obrigatório" }}
                            render={({ field: { ref, ...field }, fieldState: { error } }) => (
                                <TextField
                                    {...field}
                                    id="edit-company-phone"
                                    label="Telefone da Empresa"
                                    variant="outlined"
                                    type="tel"
                                    inputRef={ref}
                                    error={!!error}
                                    helperText={error?.message}
                                    InputProps={{
                                        inputComponent: IMaskInput,
                                    }}
                                    inputProps={{
                                        mask: "(00)00000-0000"
                                    }}
                                />
                            )}
                        />
                        <Controller
                            name="zipcode"
                            control={editMethods.control}
                            rules={{
                                required: "CEP é obrigatório",
                                pattern: {
                                    value: /^\d{5}-\d{3}$/,
                                    message: "CEP deve estar no formato 00000-000"
                                }
                            }}
                            render={({ field: { ref, ...field }, fieldState: { error } }) => (
                                <TextField
                                    {...field}
                                    id="edit-company-zipcode"
                                    label="CEP"
                                    variant="outlined"
                                    inputRef={ref}
                                    error={!!error}
                                    helperText={error?.message}
                                    InputProps={{
                                        inputComponent: IMaskInput,
                                    }}
                                    inputProps={{
                                        mask: "00000-000"
                                    }}
                                />
                            )}
                        />
                        <Controller
                            name="address"
                            control={editMethods.control}
                            rules={{ required: "Endereço é obrigatório" }}
                            render={({ field, fieldState: { error } }) => (
                                <TextField
                                    {...field}
                                    id="edit-company-address"
                                    label="Endereço"
                                    variant="outlined"
                                    error={!!error}
                                    helperText={error?.message}
                                    disabled={loadingCep}
                                />
                            )}
                        />
                        <Box display='flex' gap={1}>
                            <Controller
                                name="city"
                                control={editMethods.control}
                                rules={{ required: "Cidade é obrigatória" }}
                                render={({ field, fieldState: { error } }) => (
                                    <TextField
                                        {...field}
                                        id="edit-company-city"
                                        label="Cidade"
                                        variant="outlined"
                                        error={!!error}
                                        helperText={error?.message}
                                        disabled={loadingCep}
                                    />
                                )}
                            />
                            <Controller
                                name="state"
                                control={editMethods.control}
                                rules={{ required: "Estado é obrigatório" }}
                                render={({ field, fieldState: { error } }) => (
                                    <TextField
                                        {...field}
                                        select
                                        id="outlined-basic"
                                        label="Estado"
                                        variant="outlined"
                                        disabled={loadingCep}
                                        error={!!error}
                                        helperText={error?.message}
                                        sx={{ minWidth: 200 }}
                                    >
                                        {statesOptions.map((option) => (
                                            <MenuItem key={option} value={option}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}
                            />
                        </Box>
                    </Box>


                </form>
            </PetModal>

            <Layout height="calc(100vh - 100px)">
                <Box marginBottom='10px'>
                    <Typography variant="h4" component="h1" color="primary">
                        Empresas
                    </Typography>
                </Box>

                <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '20px' }}>
                    <Tabs value={currentTab} onChange={handleTabChange} aria-label="tabs de empresas">
                        <Tab label="Compania" />
                        <Tab label="Whatsapp" />
                    </Tabs>
                </Box>

                {currentTab === 0 && (
                    <>
                        <Box marginBottom="10px" width="100%" display="flex" justifyContent="flex-end" className="gap-1">
                            <Button
                                style={{ textTransform: "none" }}
                                color="primary"
                                variant="contained"
                                onClick={() => handleOpenModalCompany()}
                                disabled={loading.create}
                            >
                                <Typography>
                                    Nova Empresa
                                </Typography>
                            </Button>
                            <FilterCompany onFilter={loadData} />
                        </Box>

                        <Box display={{ xs: 'block', sm: 'none' }}>
                            {loading.loadData ? (
                                <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
                                    <CircularProgress size={20} />
                                </Box>
                            ) : rows.length === 0 ? (
                                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="200px" sx={{ color: '#9CA3AF' }}>
                                    <Typography variant="body1" color="textSecondary">
                                        Nenhuma empresa encontrada
                                    </Typography>
                                </Box>
                            ) : (
                                rows.map((row) => (
                                    <Card key={row.id} sx={{ mb: 2, borderRadius: 2, boxShadow: 3 }}>
                                        <CardHeader
                                            title={
                                                <Typography variant="subtitle1" fontWeight={600}>
                                                    {row.name}
                                                </Typography>
                                            }
                                            action={
                                                <IconButton
                                                    onClick={(event) => handleClick(event, row)}
                                                    size="small"
                                                >
                                                    <MoreHorizIcon />
                                                </IconButton>
                                            }
                                        />
                                        <CardContent>
                                            <Box display="flex" alignItems="center" gap={1} mb={1}>
                                                <Typography variant="body2" color="textSecondary">
                                                    ID:
                                                </Typography>
                                                <Typography variant="body2">
                                                    {row.id}
                                                </Typography>
                                            </Box>
                                            <Box display="flex" alignItems="center" gap={1} mb={1}>
                                                <Typography variant="body2" color="textSecondary">
                                                    Documento:
                                                </Typography>
                                                <Typography variant="body2">
                                                    {row.document}
                                                </Typography>
                                            </Box>
                                            <Box display="flex" alignItems="center" gap={1} mb={1}>
                                                <Typography variant="body2" color="textSecondary">
                                                    Email:
                                                </Typography>
                                                <Typography variant="body2">
                                                    {row.email}
                                                </Typography>
                                            </Box>
                                            <Box display="flex" alignItems="center" gap={1} mb={1}>
                                                <Typography variant="body2" color="textSecondary">
                                                    Telefone:
                                                </Typography>
                                                <Typography variant="body2">
                                                    {row.phone}
                                                </Typography>
                                            </Box>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <Typography variant="body2" color="textSecondary">
                                                    Proprietário:
                                                </Typography>
                                                <Typography variant="body2">
                                                    {row.ownerUser?.name || 'Não cadastrado'}
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                ))
                            )}
                        </Box>


                        <Box display={{ xs: 'none', sm: 'block' }} >
                            <Container>

                                <Box display={{ xs: 'none', sm: 'block' }}>
                                    {loading.loadData ? (
                                        <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
                                            <CircularProgress size={20} />
                                        </Box>
                                    ) : (
                                        <TableContainer component={Paper}>
                                            <Table sx={{ width: '100%', height: '100%', overflowY: 'auto' }} aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>ID</TableCell>
                                                        <TableCell>Nome</TableCell>
                                                        <TableCell>Documento</TableCell>
                                                        <TableCell>Email</TableCell>
                                                        <TableCell>Telefone</TableCell>
                                                        <TableCell>Proprietário</TableCell>
                                                        <TableCell align="right">Ações</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {rows.length > 0 ? (
                                                        rows.map((row, index) => (
                                                            <TableRow
                                                                key={row.id || index}
                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                            >
                                                                <TableCell component="th" scope="row">
                                                                    {row.id}
                                                                </TableCell>
                                                                <TableCell>{row.name}</TableCell>
                                                                <TableCell>{row.document}</TableCell>
                                                                <TableCell>{row.email}</TableCell>
                                                                <TableCell>{row.phone}</TableCell>
                                                                <TableCell>{row.ownerUser?.name || 'Não cadastrado'}</TableCell>
                                                                <TableCell align="right">
                                                                    <IconButton
                                                                        onClick={(event) => handleClick(event, row)}
                                                                        size="small"
                                                                    >
                                                                        <MoreHorizIcon />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell colSpan={7} align="center">
                                                                {loading.loadData ? (
                                                                    <CircularProgress size={20} />
                                                                ) : (
                                                                    'Nenhuma empresa encontrada'
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    )}
                                </Box>
                            </Container>
                        </Box>
                    </>
                )}

                {currentTab === 1 && (
                    <Container>
                        {loadingWhatsapp ? (
                            <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
                                <CircularProgress size={20} />
                            </Box>
                        ) : whatsappQrCode ? (
                            <Box
                                display='flex'
                                flexDirection='column'
                                alignItems='center'
                                justifyContent='center'
                                height='100%'
                                gap={2}
                            >
                                <Typography variant="h6" component="h2">
                                    QR Code do WhatsApp
                                </Typography>
                                <Typography variant="body2" color="text.secondary" textAlign="center">
                                    Escaneie este QR Code com o WhatsApp para conectar
                                </Typography>
                                {whatsappQrCode.qrcode && (
                                    <img src={whatsappQrCode.qrcode} alt="QR Code WhatsApp" />
                                )}

                                <Typography variant="body2" color="primary">
                                    Status: {whatsappQrCode.isAuthenticated ? 'Autenticado' : 'Não autenticado'}
                                </Typography>

                                <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={loadWhatsappQrCode}
                                    style={{ textTransform: "none" }}
                                    disabled={whatsappQrCode.isAuthenticated}
                                >
                                    Atualizar QR Code
                                </Button>
                            </Box>
                        ) : (
                            <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
                                <Typography variant="body1" color="text.secondary">
                                    Não foi possível carregar o QR Code do WhatsApp
                                </Typography>
                            </Box>
                        )}
                    </Container>
                )}
            </Layout>

            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    sx: {
                        minWidth: 120,
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                    }
                }}
            >
                <MenuItem
                    onClick={() => {
                        handleEditCompany(selectedCompany);
                        handleClose();
                    }}
                    sx={{ py: 1 }}
                >
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Editar</ListItemText>
                </MenuItem>
                <MenuItem
                    sx={{ py: 1, color: 'error.main', p: 0 }}
                >
                    <ConfirmButton
                        title="Excluir Empresa"
                        message={`Tem certeza que deseja excluir a empresa "${selectedCompany?.name}"? Esta ação não pode ser desfeita.`}
                        confirmText="Excluir"
                        cancelText="Cancelar"
                        confirmColor="error"
                        variant="text"
                        size="small"

                        onConfirm={() => handleDeleteCompany(selectedCompany)}
                        onCancel={handleClose}
                        sx={{
                            width: '100%',
                            justifyContent: 'flex-start',
                            color: 'error.main',
                            textTransform: 'none',
                            p: 1.5
                        }}
                    >
                        <Box display="flex" alignItems="center" className="gap-1">
                            <DeleteIcon />
                            <Typography>
                                Excluir
                            </Typography>
                        </Box>

                    </ConfirmButton>
                </MenuItem>
            </Popover>
        </>

    )
}